import { Pipe, PipeTransform } from '@angular/core';

import { tiposVenda, isAmostraPendente } from '../config-pedido-tipo-venda-indicador';

@Pipe({
    name: 'pedidoTipoVendaAbreviacao'
})
export class ConfigPedidoTipoVendaAbreviacaoPipe implements PipeTransform {
    transform(value: number, statusAmostra: number = null): string {
        if (!value) {
            return '';
        }

        const index = tiposVenda.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            // Amostra Pendente
            if (isAmostraPendente(value, statusAmostra)) {
                return tiposVenda[index].abreviacaoAmostraPendente;
            }

            return tiposVenda[index].abreviacao;
        }
        return '';
    }
}
